import Snackbar from 'components/snackbar';
import useDelayedShowOrHide from 'hooks/useDelayedShowOrHide';
import genericAlertIcon from 'images/alert.svg';
import redAlertIcon from 'images/red-alert.svg';
import whiteCloseChevronIcon from 'images/white-close-chevron.svg';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { translationWithErrorHandling } from '../../../../translation/handleMissingTranslation';
import './index.scss';
type Props = {
	isDrivingImpaired: boolean;
	penalty: number;
	dockControllerStatus?: any;
};

const showOrHideConfig = {
	showDelayMs: 0, // show the indicator immediately when driving is impaired
	hideDelayMs: 1000, // hide the indicator after a delay of X ms, when driving is no longer impaired
};

export default function ImpairedDrivingIndicator({
	isDrivingImpaired,
	penalty,
	dockControllerStatus,
}: Props) {
	const intl = useIntl();
	const [isMinimized, setIsMinimized] = useState(false);
	const isVisible = useDelayedShowOrHide(isDrivingImpaired, showOrHideConfig);

	const icon = useMemo(() => (penalty === 1 ? redAlertIcon : genericAlertIcon), [penalty]);

	return isMinimized ? (
		<div
			className={isVisible ? 'drivingImpairmentCircle' : 'displayNone'}
			onClick={() => setIsMinimized(false)}
		>
			<div className="warningIconWrapper">
				<img src={icon} alt="" />
			</div>
		</div>
	) : isVisible ? (
		penalty === 1 ? (
			<Snackbar
				icon={icon}
				iconWrapper={whiteCloseChevronIcon}
				title={translationWithErrorHandling(intl, 'drivingImpaired.drivingLocked')}
				actionRequired={translationWithErrorHandling(
					intl,
					'drivingImpaired.theSessionConnectionIsPoorDrivingIsLockedMomentarily'
				)}
			/>
		) : (
			<Snackbar
				icon={icon}
				iconWrapper={whiteCloseChevronIcon}
				title={translationWithErrorHandling(intl, 'drivingImpaired.drivingLimited')}
				actionRequired={translationWithErrorHandling(
					intl,
					'drivingImpaired.theSessionConnectionIsUnstableDrivingSpeedNowLimitedForSafety'
				)}
			/>
		)
	) : null;
}
